var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    fill: "#E24345",
    fillOpacity: 0.28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 57.02,
    fill: "#E24345"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.772 89.943a4.466 4.466 0 1 1-6.862 5.719L66 72.855 47.097 95.542a4.456 4.456 0 0 1-3.433 1.608 4.465 4.465 0 0 1-3.43-7.327l19.95-23.943-19.953-23.823a4.465 4.465 0 0 1 .572-6.291 4.46 4.46 0 0 1 6.291.572L66 59.019l18.903-22.686a4.464 4.464 0 0 1 6.291-.572 4.465 4.465 0 0 1 .572 6.291l-19.95 23.943 19.956 23.948Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.611v71.481H0z",
    transform: "translate(39.195 30.26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredFail);
export default __webpack_public_path__ + "static/media/coloredFail.b24af12af17b7c7cb01bcd16d7f8aca6.svg";
export { ForwardRef as ReactComponent };